<script>
	export let name = undefined
  export let value = undefined
  export let url = undefined
  export let position = undefined

  $: displayName = position ? ` | ${name}`: name
  $: isLoading = value ? false : true
</script>

{ #if url }
    <a href="{ url }" class="mini-card" class:loading={isLoading}>
      <p>
        { #if position}
          <span class="position">#{ position }</span>
        { /if }
        { displayName }
      </p>
      <div class="score">
        <span class="value">{ value }</span>
      </div>
    </a>
  { :else }
    <div class="mini-card" class:loading={isLoading}>
      <p>
        { #if position}
          <span class="position">#{ position }</span>
        { /if }
        { displayName ?? '. . .' }
      </p>
      
      <div class="score">
        <span class="value">{ value ?? '0' }</span>
      </div>
    </div>
{ /if }

<style type="text/scss">
  @keyframes pulse {
    50% {
      opacity: .5;
    }
  }

  .mini-card {
    background-color: white;
    position: relative;
    display: flex;
    flex-wrap: nowrap;
    align-items: stretch;
    -webkit-border-radius: 5px;
    border-radius: 5px;
    -webkit-filter: drop-shadow(0.2em 0.2em 0.2em rgba(0, 0, 0, 0.15));
    filter: drop-shadow(0.2em 0.2em 0.2em rgba(0, 0, 0, 0.15));
    font-weight: 700;
    overflow: hidden;
    color: var(--uc-black);
  }

  .mini-card:hover, .mini-card:focus {
    text-decoration: none;
    color: var(--uc-red);
  }

  .mini-card p {
    text-align: left;
    line-height: 2;
    flex-grow: 1;
    margin: 0;
    padding: 8px 1.5rem;
    flex-basis: 90%;
  }

  .score {
    flex-basis: 15%;
    display: flex;
    align-items: center;
    justify-content: center;
    align-content: center;
    text-align: center;
    color: white;
    text-align: right;
    padding: 0.25em 0.5em;
    background: #3f3f3f;
    line-height: 2.3;
    max-width: 20%;
  }
  .score {
    background: #ad011a;
  }
  
  .mini-card p span {
    color: var(--uc-red);
  }

  .loading {
    animation: pulse 2s cubic-bezier(.4,0,.6,1) infinite;
    color:rgba(100, 100, 100, 0.35)
  }

  .loading.mini-card p {
    background-color: #bbbbbb;
    color: inherit;
  }

  .loading .score span {
    color: #ad011a;
  }
</style>  